export const PROVIDER_NAMES = {
  injected: 'Injected',
  metamask: 'MetaMask',
  walletconnect: 'WalletConnect',
  coinbase: 'Coinbase Wallet',
};
